// extracted by mini-css-extract-plugin
module.exports = {"pageName":"Reminders_pageName__2PKO-","button":"Reminders_button__3GlSp","buttonTitle":"Reminders_buttonTitle__2zNX_","icon":"Reminders_icon__2MwxT"};